import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { DeleteServiceCaller, GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import DeleteModal from '../../../components/DeletePopUpComponent';


const ObsoleteAssets = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Obsolete Report"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [obsoleteAssetListData, setObsoleteAssetListData] = useState([]);
const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
 
    const [loading, setLoading] = useState(true);

    const columns = {
        AssetName: { text: "Asset Name",  width:"60px",align: "start", visible: true },
        Description: { text: "Description", width:"180px",align: "left", visible: true },
        Remarks: { text: "Issues",width:"150px", align: "left", visible: true },


    };



    useEffect(() => {
        fetchGetObsoleteReport();
    }, []);
    const [apiStatus, SetApiStatus] = useState(undefined);
    const fetchGetObsoleteReport = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}asset-obsolutes`);
            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setObsoleteAssetListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Vendor Master. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Vendor Master:", error);
        }
    };


    const openDeleteModal = (item) => {
        setShowDeleteModal(true);
        setSelectedDeleteItem(item);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedDeleteItem(null);
    };

    const handleModalDelete = async () => {
        if (!selectedDeleteItem) return;

        try {
            await DeleteServiceCaller(`${API_URL}asset-obsolutes/${selectedDeleteItem.ID}`, {}, "delete");
            closeDeleteModal();
        } catch (error) {
            console.error("Error deleting data:", error);
        }
    };

    const handleDeleteClose = () => {
        setShowDeleteModal(false);
        setSelectedDeleteItem(null);
    };



    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={obsoleteAssetListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={false}
                            showIcon2={true}
                            isSorting={true}
                            isActionRequired={true}
                            isAddNewBtnRequired={false}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleIcon2={openDeleteModal}
                            // handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon2Text: " Delete",
                                Icon2Flag:"canDelete",
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>
                <DeleteModal
                    show={showDeleteModal}
                    onClose={handleDeleteClose}
                    onConfirm={handleModalDelete}
                    message="Are you sure you want to delete this item?"
                />
            </div>

        </>
    )
}

export default ObsoleteAssets